import { LineupEntry } from "@aura-frontend/omnibus-az-client";
import type { ColumnDef } from "@tanstack/react-table";
import { Table } from "@win-reality/react-ui";

import { useRosterPlayerColumns } from "./RosterPlayersTable.columns";

type RosterPlayersTableProps = {
  unofficialMembers: LineupEntry[];
  rosterId: string;
};

function RosterPlayersTable({
  unofficialMembers,
  rosterId,
}: RosterPlayersTableProps) {
  const { rosterPlayerColumns } = useRosterPlayerColumns({ rosterId });

  return (
    <Table
      variant="infinite-scroll"
      enableHorizontalScroll
      size="compact"
      cellClassName="!bg-transparent"
      rowClassName="hover:bg-[hsla(218,100%,52%,0.1)]"
      tableWrapperClassName="overflow-auto px-2"
      columns={
        rosterPlayerColumns as unknown as ColumnDef<Record<string, unknown>>[]
      }
      data={unofficialMembers as unknown as Record<string, unknown>[]}
    />
  );
}

export { RosterPlayersTable };
